import { defaultListener } from "../helper"

export default {
  state: {
    tenantConfigs: {}, // Map ID => Configs
    platformConfig: {}, // Object of platform config
    timezones: {}
  },
  getters: {
    getTimezones(state) {
      return Object.values(state.timezones)
    }
  },
  actions: {
    fetchPlatformUpcomingInvoice({}, data){
      // handle if not logged in here as well
      const payload = { ...data }
      return this.$api.post('/api/platform/upcoming', payload)
    },
    fetchPlatformPlans({ }, data = {}) {
      const { headers: _headers = {} } = data
      // handle if not logged in here as well
      const payload = {
        headers: _headers
      }
      return this.$api.get('/api/platform/plans', payload)
    },
    initTenantConfigs({ commit, getters }) {
      // needed to allow overriding later
      const userTenants = getters.getUserTenants

      userTenants.forEach(tenantId => {
        this.$firebase.firestore()
          .collection('configs')
          .doc(tenantId)
          .onSnapshot(defaultListener.bind(this, commit, 'ADD_TENANT_CONFIG', 'REMOVE_TENANT_CONFIG'),
            e => console.log(e))
      })
    },
    initPlatformConfig({ commit }) {
      this.$firebase.firestore()
        .collection('configs')
        .doc('platform')
        .onSnapshot(defaultListener.bind(this, commit, 'ADD_PLATFORM_CONFIG', 'REMOVE_PLATFORM_CONFIG'),
          e => console.log(e))
    },
    async requestPlatformInvite({}, data) {
      const { email, name } = data

      const payload = { email, name }

      await this.$api.post('/public/platform/request-invite', payload)
    },
    listTimezones({ commit }) {
      return this.$api.get('/api/util/timezones')
        .then(res => {
          commit('SET_TIMEZONES', res.data)
        })
    }
  },
  mutations: {
    ADD_PLATFORM_CONFIG(state, config) {
      state.platformConfig = config
    },
    REMOVE_PLATFORM_CONFIG(state) {
      state.platformConfig = {}
    },
    ADD_TENANT_CONFIG(state, config) {
      // config ID is the tenant ID
      const { id } = config

      if (id) {
        const newState = { ...state.tenantConfigs }
        newState[ id ] = config
        state.tenantConfigs = newState
      }
    },
    REMOVE_TENANT_CONFIG(state, id) {
      if (state.tenantConfigs[ id ]) {
        const newState = { ...state.tenantConfigs }
        delete newState[ id ]
        state.tenantConfigs = newState
      }
    },
    SET_TIMEZONES(state, map) {
      state.timezones = { ...map }
    }
  }
}
